import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { env } from '../../environments/environment';
import { Flag } from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class PictureService {
  constructor(protected http: HttpClient) {}

  updateMarkup(id: number, markup) {
    return this.http.put<any>(`${env.APIUrl}/picture/${id}/markup`, markup).toPromise();
  }

  rotate({ id, degree }) {
    return this.http.put<any>(`${env.APIUrl}/picture/${id}/rotate`, { degree }).toPromise();
  }

  bulkRotate(payload) {
    return this.http.put<any>(`${env.APIUrl}/picture/rotate`, payload).toPromise();
  }

  updateDefaultKey(id: number, key) {
    return this.http.put<any>(`${env.APIUrl}/picture/${id}/key`, { key }).toPromise();
  }

  getFlags(pictureId: number) {
    return this.http.get<Flag[]>(`${env.APIUrl}/picture/${pictureId}/flags`).toPromise();
  }

  remove(id: number) {
    return this.http.delete<any>(`${env.APIUrl}/picture/${id}`).toPromise();
  }

  removePictureWithFlags(id: number) {
    return this.http.delete<any>(`${env.APIUrl}/picture/${id}/pictureWithFlags`).toPromise();
  }

  download(ids: number[], markup = false) {
    return this.http.post<any>(`${env.APIUrl}/picture/download`, { ids, markup }).toPromise();
  }

  downloadByGalleryToken(token: string, payload: { ids: number[]; markup?: boolean; email: string }) {
    return this.http.post<any>(`${env.APIUrl}/inspection/by-gallery-token/${token}/download`, payload).toPromise();
  }
}
